export const appendUrlParam = ({
  navigate,
  location,
  paramName,
  paramKey
}) => {
  const url = new URL(window.location);
  if (typeof paramName !== 'string' || url.searchParams.has(paramKey)) return;
  url.searchParams.set(paramKey, paramName);
  const target = `${location.pathname}${url.search}`;
  navigate(target);
};

export const removeUrlParam = ({ navigate, location, paramKey }) => {
  const url = new URL(window.location);
  url.searchParams.delete(paramKey);
  const target = `${location.pathname}${url.search}`;
  navigate(target);
};
